export function getTierAmountYuan(t) {
  const n = Number(t?.amount_yuan)
  return Number.isFinite(n) ? n : 0
}

export function sortFirstDepositTiersByAmountAsc(tiers) {
  if (!Array.isArray(tiers)) return []
  return [...tiers].sort((a, b) => getTierAmountYuan(a) - getTierAmountYuan(b))
}
